import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src", "srcset", "alt"]

import { ref, watchEffect, onMounted, nextTick } from "vue";

import { getIcon } from "~/js/composables/icons";
import { getClasses } from "~/js/composables/classes";

import { Image } from "~/js/interfaces/media";

import Badge from "~/vue/atoms/badges/BadgePrimary.vue";

interface Props {
	animate?: boolean;
	images: Array<Image>;
	headings?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SliderBeforeAfter',
  props: {
    animate: { type: Boolean, default: false },
    images: {},
    headings: { default: null }
  },
  setup(__props: any) {

const props = __props;

const container = ref(null);
const range = ref(50);
const imageSize = ref({ width: 0, height: 0 });
const image = ref(props.images[0]);
const classes = ref({
	wrapper: {
		grid: "grid grid-cols-1",
		position: "relative aspect-video",
		layout: "overflow-hidden rounded-3xl shadow-image",
		size: "w-full",
	},
	figure: {
		grid: "row-start-1 col-start-1",
		position: "relative",
	},
	figcaption: {
		position: "absolute top-4",
	},
	image: {
		object: "object-cover object-left-bottom",
		ratio: "aspect-video",
		size: "max-w-none",
	},
});

watchEffect(() => {
	if (container.value) {
		container.value.style.setProperty("--position", `${range.value}%`);
	}
});

const setSize = () => {
	imageSize.value = {
		width: 0,
		height: 0,
	};

	nextTick(() => {
		if (container.value) {
			imageSize.value = {
				width: container.value.offsetWidth + "px",
				height: container.value.offsetHeight + "px",
			};
		}
	});
};

onMounted(() => {
	window.addEventListener("resize", setSize);
	setSize();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: _normalizeClass([_unref(getClasses)(classes.value, 'wrapper'), __props.animate ? 'animate-slide-from-left' : '', 'slider-container'])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image, i) => {
      return (_openBlock(), _createElementBlock("figure", {
        key: image.alt,
        "aria-labelledby": image.alt,
        class: _normalizeClass(_unref(getClasses)(classes.value, 'figure'))
      }, [
        _createElementVNode("picture", {
          class: _normalizeClass(i == 0 ? 'block w-full' : 'relative block w-[var(--position)] overflow-hidden')
        }, [
          _createElementVNode("source", {
            srcset: image.srcsetWebP,
            sizes: "[100vw]",
            type: "image/webp"
          }, null, 8, _hoisted_2),
          _createElementVNode("source", {
            srcset: image.srcset,
            sizes: "[100vw]"
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            src: image.placeholder,
            srcset: image.srcset,
            sizes: "[100vw]",
            class: _normalizeClass(_unref(getClasses)(classes.value, 'image')),
            alt: image.alt,
            loading: "lazy",
            style: _normalizeStyle(imageSize.value)
          }, null, 14, _hoisted_4),
          (i > 0 && __props.headings?.before)
            ? (_openBlock(), _createElementBlock("figcaption", {
                key: 0,
                class: _normalizeClass(['left-4', _unref(getClasses)(classes.value, 'figcaption')])
              }, [
                _createVNode(Badge, {
                  style: { background: 'bg-white' },
                  content: __props.headings.before
                }, null, 8, ["content"])
              ], 2))
            : _createCommentVNode("", true),
          (i == 0 && __props.headings?.after)
            ? (_openBlock(), _createElementBlock("figcaption", {
                key: 1,
                class: _normalizeClass(['right-4', _unref(getClasses)(classes.value, 'figcaption')])
              }, [
                _createVNode(Badge, {
                  style: { background: 'bg-white' },
                  content: __props.headings.after
                }, null, 8, ["content"])
              ], 2))
            : _createCommentVNode("", true)
        ], 2)
      ], 10, _hoisted_1))
    }), 128)),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"absolute inset-0 h-full w-full\"><div class=\"absolute left-[var(--position)] top-0 h-full w-1 -translate-x-0.5 bg-orange-500 shadow-xl\"></div><div class=\"absolute left-[var(--position)] top-1/2 h-14 w-14 -translate-x-[1.75rem] -translate-y-[1.75rem] rounded-full bg-orange-500 shadow-xl\"><span class=\"absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rotate-90 text-3xl text-white\"><i class=\"fa-light fa-arrows-from-line\"></i></span></div></div>", 1)),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
      type: "range",
      min: "0",
      max: "100",
      value: "50",
      "aria-label": "Percentage of before photo",
      class: "absolute inset-0 h-full w-full cursor-pointer opacity-0"
    }, null, 512), [
      [_vModelText, range.value]
    ])
  ], 2))
}
}

})